import styled from 'styled-components';
import UIBox from 'UIComponents/layout/UIBox';
import { AsyncUIAvatar } from '../../../code-splitting/public';
import StatusIndicator from './StatusIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContactAvatarWrapper = styled(UIBox).withConfig({
  displayName: "ContactAvatar__ContactAvatarWrapper",
  componentId: "yvpidw-0"
})(["position:relative;display:table;"]);
const ContactAvatar = ({
  isKnownContact,
  email,
  contactDetail,
  vid,
  threadId
}) => {
  return /*#__PURE__*/_jsxs(ContactAvatarWrapper, {
    children: [/*#__PURE__*/_jsx(AsyncUIAvatar
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ className: string; size: string; type: str... Remove this comment to see the full error message
    , {
      size: "sm",
      type: "contact",
      email: isKnownContact ? email : undefined,
      displayName: isKnownContact ? contactDetail : undefined,
      vid: isKnownContact ? vid : undefined
    }), threadId && /*#__PURE__*/_jsx(StatusIndicator, {
      threadId: threadId
    })]
  });
};
ContactAvatar.displayName = 'ContactAvatar';
export default ContactAvatar;